import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import HomeScreen from './home';
import LiquoursScreen from './liquours';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setshowHome] = useState(false);
    const [showLiquours, setshowLiquours] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [appetizers, setappetizers] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [dataCarne, setdataCarne] = useState(false);
    const [dataMothers, setDataMothers] = useState(false);




     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
                if (item.id === 462) {
                    setappetizers(item);
                }
                 if (item.id === 469) {
                    setcarnte(item);
                }
                if (item.id === 596) {
                    setDataMothers(item);
                }
            });
      }, [menus]);
    
    
     useEffect(() => {
         if (carnte) {
             carnte.menus.map((item) => {
                 if (item.id === 4375) {
                  setdataCarne(item)
                
               }
           })
       }
     }, [carnte]);
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
        setshowHome(false)
        setshowLiquours(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setshowHome(false)
            setshowLiquours(false)
            getInitData();
            

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
        <div style={{
            minHeight: '100vh',
            width: '100%',
            background: 'linear-gradient(180deg, #E6D6EC 0%, #AD00FD 40%, #F00101 69%, #000000 100%)',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            {/* Overlay oscuro */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.45)',
                    pointerEvents: 'none',
                    zIndex: 1,
                }}
            />

            {/* Contenido por encima del overlay */}
            <div style={{ position: 'relative', zIndex: 2 }}>
                <div style={{ width: '100%', position: 'relative'}}>
                    <img
                        style={{
                            marginTop: 20,
                            width: 600,
                            height: 180,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',

                            
                        }}
                        src={require('./assets/logo2.png')}
                    />
                   
                </div>
            </div>

            <div>
                <div style={{position: 'relative', zIndex: 2}} onClick={() => {
                    setshowLiquours(true)
                }}>
                    <img src={require('./assets/liquoursbtn.png')} alt="logo" />
                </div>

               

                  <div style={{position: 'relative', zIndex: 2}} onClick={() => {
                    setshowHome(true)
                  }}>
                    <img src={require('./assets/foodanddrinkbtn.png')} alt="logo" />
                </div>
                 <div style={{ position: 'relative', zIndex: 2, marginTop: 12, marginBottom: 12 }}>
                    <button
                        type="button"
                        onClick={() => setshowHome(true)}
                        style={{
                            background: '#ffffff',
                            color: '#000000',
                            border: 'none',
                            borderRadius: 10,
                            padding: '12px 24px',
                            fontSize: 20,
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        See Menu
                    </button>
                </div>
            </div>

            {showHome && <HomeScreen setshowHome={setshowHome} />}
            {showLiquours && <LiquoursScreen setshowLiquours={setshowLiquours} />}
            </div>
    );
}

export default Index;